import { buildReproduction, buildTimeline as buildFrom, type Reproduction, type Ticket, type Timeline, type TimelineInput } from '@vd/types';

export type { Timeline, TimelineEntry, TimelineKind } from '@vd/types';
export { MAX_TIMELINE_ENTRIES } from '@vd/types';

/** What a ticket's timeline is built from, as `GET /tickets/:id/timeline` reads it. */
function timelineInput(ticket: Ticket): TimelineInput {
  const t = ticket as Ticket & { console?: unknown; network?: unknown; errors?: unknown };
  return {
    console: t.console,
    errors: t.errors,
    network: t.network,
    timeOrigin: ticket.capture?.browser?.timeOrigin,
    session: ticket.capture?.session,
    reportedAt: ticket.createdAt,
  };
}

/** A ticket's timeline (TOADO-911), built by the shared builder in `@vd/types`. */
export function buildTimeline(ticket: Ticket): Timeline {
  return buildFrom(timelineInput(ticket));
}

/**
 * A ticket's reproduction (TOADO-926): its steps and a Playwright test, from the same input as
 * its timeline, so the Session window copies what `GET /tickets/:id/reproduction` answers.
 */
export function buildTicketReproduction(ticket: Ticket): Reproduction {
  return buildReproduction({ ...timelineInput(ticket), ticketId: ticket.id, ...(ticket.sourceUrl ? { sourceUrl: ticket.sourceUrl } : {}) });
}
